import URLS from 'constants/urls';
import { transformKeysToCamelCase, transformKeysToSnakeCase } from 'helpers/core';
import { reportError } from 'helpers/error-logging';
import { httpClient } from 'helpers/http';
import {
  BookingUserFeedbackRequest,
  BookingUserFeedbackResponse,
  VenueUserFeedbackRequest,
  VenueUserFeedbackResponse,
} from '@classpass/protobuf-definitions/lib/web/models/partners/reservation';

export function getReservationFeedbackAlreadyReported(feedback) {
  return {
    disruptiveUserAlreadyReported: !!feedback?.disruptiveUserReported,
    trialAbuseAlreadyReported: !!feedback?.trialAbuseReported,
  };
}

export async function submitReservationFeedback({ reservationId, feedback, description }) {
  try {
    const payload = VenueUserFeedbackRequest.toJSON(
      transformKeysToSnakeCase({
        reservationId,
        feedback,
        description,
      })
    );
    const response = await httpClient.post(URLS.schedule.submitReservationFeedback, payload);
    const data = transformKeysToCamelCase(VenueUserFeedbackResponse.fromJSON(response?.data ?? {}));
    return { isPaid: data.isPaid ?? false };
  } catch (error) {
    reportError(error);
    throw error;
  }
}

export async function submitBookingFeedback({ bookingType, bookingId, feedback, description }) {
  try {
    const payload = BookingUserFeedbackRequest.toJSON(
      BookingUserFeedbackRequest.fromJSON({
        booking_id: bookingId,
        booking_type: bookingType,
        feedback,
        description,
      })
    );
    const response = await httpClient.post(URLS.schedule.submitBookingFeedback, payload);
    const data = transformKeysToCamelCase(BookingUserFeedbackResponse.fromJSON(response?.data ?? {}));
    return { isPaid: data.isPaid ?? false };
  } catch (error) {
    reportError(error);
    throw error;
  }
}
